import { ChangeDetectionStrategy, Component, computed, effect, inject, input, signal } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { DsAlert } from '@frontend/ui/alert';

import { PlayerStatisticMessages, PlayerStatisticsStoreData, StatisticsInput } from './player-statistics.model';
import { PlayerStatisticsService } from './player-statistics.service';

@Component({
    selector: 'ms-player-statistics',
    styleUrl: 'player-statistics.component.scss',
    templateUrl: './player-statistics.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [DsAlert],
})
export class PlayerStatisticsComponent {
    params = input<StatisticsInput>();
    statistics = input<PlayerStatisticsStoreData>();
    messages = input<PlayerStatisticMessages>();
    isIframeLoading = signal(true);
    safeUrl = signal<SafeResourceUrl | undefined>(undefined);

    sanitizer = inject(DomSanitizer);
    playerStatisticsService = inject(PlayerStatisticsService);

    private isReady = computed(() => {
        const storeData = this.statistics();
        if (!storeData) {
            return false;
        }
        const { isLoading, isError, data } = storeData;
        return !isLoading && !isError && !!data && !!this.params();
    });

    constructor() {
        effect(() => {
            const store = this.statistics();
            const params = this.params();
            if (this.isReady() && store && params) {
                const graphUrl = this.playerStatisticsService.getPlayerStatisticsGraph(store.data, params);
                if (graphUrl) {
                    this.safeUrl.set(this.sanitizer.bypassSecurityTrustResourceUrl(graphUrl));
                    this.isIframeLoading.set(true);
                    return;
                }
            }
            this.safeUrl.set(undefined);
            this.isIframeLoading.set(false);
        });
    }

    onIframeLoad() {
        this.isIframeLoading.set(false);
    }
}
